// Independent of the current pilot's REACT_APP_SIGNALR_API_URL setting.
export function readRealtimeConfig(env = {
  enabled: process.env.REACT_APP_REALTIME_V2_ENABLED,
  gatewayUrl: process.env.REACT_APP_REALTIME_V2_GATEWAY_URL,
  signalrOrigin: process.env.REACT_APP_REALTIME_V2_SIGNALR_ORIGIN,
  scope: process.env.REACT_APP_REALTIME_V2_SCOPE,
  environment: process.env.REACT_APP_REALTIME_V2_ENVIRONMENT,
}) {
  if (env.enabled !== 'true') return Object.freeze({ enabled: false });
  const gateway = new URL(env.gatewayUrl);
  const service = new URL(env.signalrOrigin);
  if (gateway.protocol !== 'https:' || gateway.username || gateway.password || gateway.search || gateway.hash
    || !gateway.pathname.replace(/\/+$/, '').endsWith('/api/realtime')) throw new Error('INVALID_REALTIME_GATEWAY');
  if (service.protocol !== 'https:' || !service.hostname.endsWith('.service.signalr.net')
    || service.pathname !== '/' || service.port || service.username || service.password || service.search || service.hash) throw new Error('INVALID_SIGNALR_ORIGIN');
  if (!['dev', 'uat', 'production'].includes(env.environment)) throw new Error('INVALID_REALTIME_ENVIRONMENT');
  if (typeof env.scope !== 'string' || !env.scope.includes('/') || /\s/.test(env.scope)) throw new Error('INVALID_REALTIME_SCOPE');
  return Object.freeze({ enabled: true, gatewayUrl: gateway.href.replace(/\/+$/, ''),
    signalrOrigin: service.origin, scope: env.scope, environment: env.environment });
}
